var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.35 4V4.15H17.5H19.5C20.5202 4.15 21.35 4.97984 21.35 6V20C21.35 21.0202 20.5202 21.85 19.5 21.85H5.5C4.47984 21.85 3.65 21.0202 3.65 20V6C3.65 4.97984 4.47984 4.15 5.5 4.15H7.5H7.65V4V2.15H9.35V4V4.15H9.5H15.5H15.65V4V2.15H17.35V4ZM19.502 20.15H19.652L19.652 20L19.65 7.99998L19.65 7.85H19.5H5.5H5.35V8V20V20.15H5.5H19.502Z",
    fill: "#F9F9F9",
    stroke: "white",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.606 14.692L15.793 10.5051L16.9948 11.707L11.5 17.2018L8.0051 13.707L9.20697 12.5051L11.3939 14.692L11.5 14.7981L11.606 14.692Z",
    fill: "#F9F9F9",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.a007134c21ccfc5170e21c3effca0964.svg";
export { ForwardRef as ReactComponent };